import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { useUserRole } from '@/hooks/useUserRole';
import ComprehensiveNotificationBell from '../notifications/ComprehensiveNotificationBell';
import UserMenu from '../UserMenu';
import MobileMainNavigation from './MobileMainNavigation';
import { GameWorkflowAutomation } from '../workflow/GameWorkflowAutomation';

const MobileHeader = () => {
  const { user: supabaseUser } = useAuth();
  const { user: internalUser } = useInternalAuth();
  const { permissions, userId } = useUserRole();
  const [isMainNavOpen, setIsMainNavOpen] = useState(false);
  
  const isAuthenticated = !!(supabaseUser || internalUser);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-gray-800 md:hidden">
        <div className="px-4 h-16 flex items-center justify-between py-1.5">
          <Link to="/" className="flex items-center">
            <img 
              src="https://gmmfphwrwhvixldazcmp.supabase.co/storage/v1/object/sign/images/PL%20Logo.svg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80Y2E1MDZiYi03YzlmLTQ3NWMtODU0My1iNzkyMTc5NjdjNjAiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvUEwgTG9nby5zdmciLCJpYXQiOjE3NTI3ODIwODUsImV4cCI6NDkwNjM4MjA4NX0.r9VxAKcMh1tB91moPz4hQCm-MqVHE_0ueHoOpq3UgDU" 
              alt="Players Lockeroom Connect" 
              className="h-8 w-auto"
            />
          </Link>

          <div className="flex items-center space-x-3">
            {isAuthenticated && (
              <>
                <ComprehensiveNotificationBell />
                <div className="relative">
                  <UserMenu />
                </div>
                <button
                  onClick={() => setIsMainNavOpen(true)}
                  className="text-white hover:text-sports-green transition-colors"
                >
                  <Menu className="h-6 w-6" />
                </button>
              </>
            )}
            {!isAuthenticated && (
              <div className="flex items-center space-x-2">
                <Link to="/agent/application-status">
                  <Button variant="ghost" size="sm" className="text-orange-400 hover:text-orange-300 text-xs px-2">
                    BETA
                  </Button>
                </Link>
                <Link to="/login">
                  <Button variant="ghost" size="sm" className="text-gray-300 hover:text-sports-green text-sm">
                    Sign In
                  </Button>
                </Link>
                <Link to="/register">
                  <Button size="sm" className="bg-sports-green hover:bg-sports-green/90 text-black text-sm">
                    Sign Up
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Mobile Main Navigation Overlay */}
      <MobileMainNavigation 
        isOpen={isMainNavOpen} 
        onClose={() => setIsMainNavOpen(false)} 
      />
      
      {/* Workflow Automation Component */}
      {isAuthenticated && (
        <GameWorkflowAutomation 
          userId={userId}
          userRole={permissions.role}
        />
      )}
    </>
  );
};

export default MobileHeader;